<template>
  <OrderHistoryBanner :openWebview="callWebview" />
</template>

<script>
import OrderHistoryBanner from '@/presentationals/v2/components/layouts/organisms/OrderHistoryBanner'

export default {
  name: 'OrderHistoryBannerContainer',
  components: {
    OrderHistoryBanner
  },
  methods: {
    callWebview() {
      const title = '이벤트'
      const url = `${process.env.VUE_APP_ORDER_HISTORY_BANNER_URL}?isHistory=true`

      window.location = `${
        process.env.VUE_APP_DEEP_LINK_PROTOCOL
      }://./webview?webview_url=${encodeURIComponent(url)}&webview_title=${encodeURIComponent(
        title
      )}`
    }
  }
}
</script>

<style lang="scss" scoped>
</style>